import React from "react";
import PaperContainer from "../../../paper-container";
import Item from "./item";

const List = ({ items, query, layer }) => {
  return (
    <PaperContainer title="Recursos de visualización">
      {items.map(item => (
        <Item key={item.id} {...item} query={query} layer={layer} />
      ))}
    </PaperContainer>
  );
};

export default List;



// WEBPACK FOOTER //
// ./src/components/admin/carto/resources/list.js